"use client";

import { createContext, PropsWithChildren, useContext, useState } from "react";

interface ShowHeaderFooterContextType {
  hideHeader: boolean;
  setHideHeader: (hide: boolean) => void;
  hideFooter: boolean;
  setHideFooter: (hide: boolean) => void;
}

const ShowHeaderFooterContext = createContext<ShowHeaderFooterContextType>({
  hideHeader: false,
  setHideHeader: () => {},
  hideFooter: false,
  setHideFooter: () => {},
});

export function ShowHeaderFooterProvider({ children }: PropsWithChildren) {
  const [hideHeader, setHideHeader] = useState(false);
  const [hideFooter, setHideFooter] = useState(false);

  return (
    <ShowHeaderFooterContext.Provider value={{ hideHeader, setHideHeader, hideFooter, setHideFooter }}>
      {children}
    </ShowHeaderFooterContext.Provider>
  );
}

export function useShowHeaderFooter() {
  return useContext(ShowHeaderFooterContext);
}
